import React from 'react';

import './newsletter.scss';

const NewsletterSubmitMessage = props => {
  const visibleClass = props.isVisible ? 'newsletter__feedback--visible' : '';
  const submittedClass = props.submitted
    ? 'newsletter__feedback--submitted'
    : '';
  return (
    <div className={`newsletter__feedback ${visibleClass} ${submittedClass}`}>
      {props.message}
    </div>
  );
};

export default NewsletterSubmitMessage;



// WEBPACK FOOTER //
// ./src/components/newsletter-submit-message.js